import styles from './Share.module.css';
import animStyles from 'ui/animation/animation.module.css';
import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';

export default class ShareWechatAlert extends Component {
  static getDerivedStateFromProps(props, state) {
    const { location } = props;
    const { prevLocation, hideResolve } = state;

    if (
      !(
        prevLocation &&
        prevLocation.pathname === location.pathname &&
        prevLocation.search === location.search
      )
    ) {
      if (hideResolve) {
        hideResolve({ cancel: true });
      }

      return {
        prevLocation: location,
        hideResolve: null,
      };
    }

    return null;
  }

  state = {
    shareDict: {},
    prevLocation: null,
    hideResolve: null,
  };

  show(shareDict) {
    if (this.state.hideResolve) {
      this.state.hideResolve({ cancel: true });
    }

    return new Promise(resolve => {
      this.setState({ hideResolve: resolve, shareDict });
    });
  }

  hide(options) {
    if (this.state.hideResolve) {
      this.state.hideResolve(options);

      this.setState({ hideResolve: null });
    }
  }

  handleCancel = () => {
    this.hide({ cancel: true });
  };

  render() {
    const { hideResolve, shareDict } = this.state;

    return (
      <CSSTransition
        in={!!hideResolve}
        timeout={200}
        classNames={{
          enter: animStyles.fadeInEnter,
          enterActive: animStyles.fadeInEnterActive,
          exit: animStyles.fadeInExit,
          exitActive: animStyles.fadeInExitActive,
          exitDone: animStyles.fadeInExitDone,
        }}
        mountOnEnter
      >
        <div className={styles.alertWrapper}>
          <span
            onClick={this.handleCancel}
            className={animStyles.transparentMask}
          >
            <span className={styles.shareMaskArrow} />
            <span className={styles.shareMaskContent}>
              {shareDict.wechatTitle}
            </span>
          </span>
        </div>
      </CSSTransition>
    );
  }
}
